import z from 'zod'

import { schema as globalSetupDefaultsMultiAnchorSchema } from 'features/globalSetup/pages/Defaults/RichPlacements/Sections/MultiAnchorSection/schema'
import { Domain } from 'features/inventory/types/domain'

export const schema = z
  .object({
    customizeAppearance: z.boolean().default(false),
    customizeBasicSettings: z.boolean().default(false),
    enabled: z.boolean().default(false),
  })
  .safeExtend(globalSetupDefaultsMultiAnchorSchema.shape)

export type Schema = z.infer<typeof schema>

export const schemaDefault = (domain: Domain): Schema => {
  const {
    domainRichPlacementMultiAnchor: {
      customizeAppearance,
      customizeBasicSettings,
      customStyling,
      displayAfterUserInteraction,
      enabled,
      fullWidthMode,
      showCloseButton,
      singleAdViewTime,
    },
  } = domain

  return {
    customizeAppearance,
    customizeBasicSettings,
    customStyling,
    displayAfterUserInteraction,
    enabled,
    fullWidthMode,
    showCloseButton,
    singleAdViewTime,
  }
}
